import { WeekDayEnum } from '@/models/dictionary/day-of-week.model';

export type UnavailableHoursTimeModel = {
  from: string;
  to: string;
};

export type UnavailableHoursConfigItemModel = {
  dayList: WeekDayEnum[];
  time: UnavailableHoursTimeModel;
};

export type UnavailableHoursSettingsModel = {
  isUnavailableHoursActive: boolean;
  unavailableHoursConfig: UnavailableHoursConfigItemModel[];
};

export type UnavailableHoursSettingsUpdateRequest = UnavailableHoursSettingsModel & {
  id: string;
};

export const DEFAULT_UNAVAILABLE_HOURS_FORM: UnavailableHoursSettingsModel = {
  isUnavailableHoursActive: false,
  unavailableHoursConfig: [],
};

export const DEFAULT_UNAVAILABLE_HOURS_CONFIG_ITEM: UnavailableHoursConfigItemModel = {
  dayList: [],
  time: { from: '', to: '' },
};

export enum UnavailableHoursStatus {
  ACTIVE = 'Active',
  DISABLED = 'Disabled',
}

export enum UnavailableHoursTextType {
  SUCCESS = 'success',
  INFO = 'info',
}

export type UnavailableHoursData = {
  type: UnavailableHoursTextType;
  value: UnavailableHoursStatus;
}

// eslint-disable-next-line max-len
export const AVAILABILITY_ACTIVE_SWITCH_TOOLTIP_TEXT = 'If enabled, this payment method is hidden during specified periods based on the user\'s local time';
// eslint-disable-next-line max-len
export const AVAILABILITY_INFO_BANNER_TEXT = 'Specified time periods are based on the user account’s time zone. Please ensure your settings are correctly configured.';

export enum UnavailableHoursActiveLabel {
  ON = 'On',
  OFF = 'Off',
}
